import { StatusStore, LastErrorStore } from '@/stores'
import constants from '@/constants'
import axios from 'axios'

/**
 * Service to access Lynx server status
 */
export default class StatusService {
  /**
   * Constructor.
   * @param {string} baseUrl Base url to connect to lynx API. typically http or https//[ip]/lynxapi
   */
  constructor (baseUrl) {
    this.baseUrl = baseUrl
    this.statusInterval = null
  }

  /**
   * Method that starts pooling to know about REST API status.
   */
  startCheckingServerStatus () {
    StatusStore().ServiceDown()
    this.checkServerStatus()
    // Annuler l'intervalle précédent s'il existe
    if (this.statusInterval) {
      clearInterval(this.statusInterval)
    }

    // Définir un nouvel intervalle
    this.statusInterval = setInterval(() => {
      this.checkServerStatus()
    }, constants.status_interval) // 3000 ms = 3 secondes
  }

  /**
   * Stop checking REST api status.
   */
  stopCheckingServerStatus () {
    if (this.statusInterval) {
      clearInterval(this.statusInterval)
      this.statusInterval = null
    }
  }

  /**
   * REST call to check status. Publishes an error message if status not OK.
   */
  checkServerStatus () {
    const statusUrl = `${this.baseUrl}/lynxapi/system/status`

    axios.get(statusUrl)
      .then(response => {
        if (response.status === 200 && response.data && response.data.result === 1) {
          StatusStore().ServiceUp()
        }
      })
      .catch(error => {
        const err = 'Erreur d\'accès au serveur: ' + error.message
        LastErrorStore().NotifyError(err)
        StatusStore().ServiceDown()
      })
  }
}
